
import moment from 'moment';
import {
  Component,
  Mixins,
} from 'vue-property-decorator';
import { isTaskCompleted, isTaskFailed } from '@/helpers';
import OperationComponentMixin from '@/mixins/OperationComponentMixin.vue';

moment.locale('it');

@Component
export default class OperationPlanDate extends Mixins(OperationComponentMixin) {
  get hasP(): boolean {
    return this.operationChild?.p === 'done' || this.operationChild?.p === 'na';
  }

  get hasC(): boolean {
    return this.operationChild?.c === 'done' || this.operationChild?.c === 'na';
  }

  get planDateViewMode(): string {
    let planDateViewMode = 'week';

    if (this.childProjectType === 'elettrica-figlia') planDateViewMode = this.operation?.ePlanDateViewMode;
    if (this.childProjectType === 'termica-figlia') planDateViewMode = this.operation?.tPlanDateViewMode;

    return planDateViewMode;
  }

  get planDate(): string | null {
    let planDate: Date | null = null;

    if (this.childProjectType === 'elettrica-figlia') planDate = this.operation?.ePlanDate;
    if (this.childProjectType === 'termica-figlia') planDate = this.operation?.tPlanDate;

    // Restituisce la data nel formato richiesto
    switch (this.planDateViewMode) {
      case 'single':
        return planDate && moment(planDate).isValid()
          ? this.mDate(planDate)
          : null;

      case 'week':
        return planDate && moment(planDate).isValid()
          ? `WW ${moment(planDate).format('WW-GGGG')}`
          : null;

      default:
        return null;
    }
  }

  get columnClass(): string {
    if (isTaskCompleted(this.operationChild, 'V')) return 'completed';
    if (isTaskFailed(this.operationChild, 'V')) return 'error';
    if (this.childProjectType === 'elettrica-figlia' && this.hasP) return 'completed';
    if (this.childProjectType === 'termica-figlia' && this.hasP && this.hasC) return 'completed';
    return '';
  }

  onEdit() {
    console.log('OperationPlanDate: onEdit()'); // eslint-disable-line no-console
    this.$emit('edit');
  }
}
